module.exports = __webpack_public_path__ + "img/sp-sort-button-down-disabled.4bbd2985.svg";